module.exports = __webpack_public_path__ + "img/Photo@2x.e74e70de.png";